/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ years: NonNullable<unknown> }} Consumption_Reference_YearsInputs */



/**
* | output |
* | --- |
* | "Ref. {years}" |
*
* @param {Consumption_Reference_YearsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_reference_years = /** @type {((inputs: Consumption_Reference_YearsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Reference_YearsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Ref. ${i?.years}`)
	return /** @type {LocalizedString} */ (`Réf. ${i?.years}`)
});